export const test_ids = {
  cookies: {
    cookieBanner: 'cookieBanner',
    acceptAllCookies: 'acceptAllCookies',
    customizeCookies: 'customizeCookies',
    onlyNecessaryCookies: 'onlyNecessaryCookies',
    cookieName: 'mioCookieConsent',
    cookiePanel: 'cookiePanel',
  },
  saveSettings: 'save-settings',
};
